import React, {useEffect} from 'react';
import {
    TileLayer,
    ZoomControl,
    ScaleControl,
    LayersControl,
    useMapEvents
} from 'react-leaflet';
import { useCookies } from "react-cookie";
import { mapConfig } from '../config/env';

const MapController = (props) => {
    const layers = mapConfig.baseLayers;
    const [cookies,setCookie,removeCookie] = useCookies(["spots","latitude","longitude"]);
    useEffect(()=>{
        setCookie("latitude", mapConfig.center.lat);
        setCookie("longitude", mapConfig.center.lng);
        setCookie("longitude", mapConfig.center.lng);
    },[]);
    useMapEvents({
        moveend(e){
            setCookie("latitude",e.target.getCenter().lat);
            setCookie("longitude",e.target.getCenter().lng);
        }
    })
    return (
        <>
            {/* 右上のレイヤコントローラ */}
            <LayersControl position="topright" autoZIndex={false}>
                {layers.map((layer, idx) => (
                    <LayersControl.BaseLayer checked={layer.checked} name={layer.name} key={layer.name + idx.toString()}>
                        <TileLayer
                            attribution={layer.attribution}
                            url={layer.url}
                            zIndex={0}
                        />
                    </LayersControl.BaseLayer>
                ))}
            </LayersControl>
            {/* 右上のレイヤコントローラ */}

            {/* 左下の縮尺 */}
            <ScaleControl position="bottomleft" />
            {/* 左下の縮尺 */}

            {/* 右下のズームコントローラ */}
            <ZoomControl position="bottomright" />
            {/* 右下のズームコントローラ */}
        </>
    )
}

export default MapController;